module.exports = __webpack_public_path__ + "img/ai_teacher_James.862be62a.png";